var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentNormalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 10H23.3335C26.6668 10 26.6668 8.33337 26.6668 6.66671C26.6668 3.33337 25.0002 3.33337 23.3335 3.33337H16.6668C15.0002 3.33337 13.3335 3.33337 13.3335 6.66671C13.3335 10 15.0002 10 16.6668 10Z",
    stroke: "#F4978E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.6667 6.70007C32.2167 7.00007 35 9.05007 35 16.6667V26.6667C35 33.3334 33.3333 36.6667 25 36.6667H15C6.66667 36.6667 5 33.3334 5 26.6667V16.6667C5 9.06674 7.78333 7.00007 13.3333 6.70007",
    stroke: "#F4978E",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNormalIcon);
export default __webpack_public_path__ + "static/media/document-normal-icon.20d69ac34c645efbd16b88fa0ed81588.svg";
export { ForwardRef as ReactComponent };